import React from "react";
import { Switch } from "@/components/ui/switch";
import {
  SortableServiceList,
  SortableServiceItem,
} from "@/components/common/SortableServiceList";
import { HotelService } from "@/types/hotelService";

const Label = ({ children, className }: any) => (
  <label className={`text-2xl font-medium ${className || ""}`}>
    {children}
  </label>
);

interface FinalTabProps {
  settings: any;
  setSettings: (settings: any) => void;
  upsellServices: SortableServiceItem[];
  setUpsellServices: (items: SortableServiceItem[]) => void;
  allServices: HotelService[];
}

export const FinalTab = ({
  settings,
  setSettings,
  upsellServices,
  setUpsellServices,
  allServices,
}: FinalTabProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Switch
            checked={settings?.isUpsellRecommendedServices}
            onCheckedChange={(checked) =>
              setSettings({ ...settings, isUpsellRecommendedServices: checked })
            }
          />
          <Label>Upsell</Label>
        </div>

        <div className="ml-6 max-w-xl">
          <SortableServiceList
            items={upsellServices}
            onReorder={setUpsellServices}
            onRemove={(id) =>
              setUpsellServices(upsellServices.filter((s) => s.id !== id))
            }
            onAdd={(serviceId) => {
              const service = allServices.find((s) => s.id === serviceId);
              if (service) {
                setUpsellServices([
                  ...upsellServices,
                  { id: service.id, serviceId: service.id, name: service.name },
                ]);
              }
            }}
            availableServices={allServices}
            placeholder="Add upsell service"
          />
        </div>
      </div>
    </div>
  );
};
